module.exports = __webpack_public_path__ + "media/images/drivers/DEFAULT-bc3d36beb1e2ef4d4fc716ff866fd8ad.png";